import { Feature, FEATURE_QUERY_ENABLED } from '@gig/magic-messages';
export { Feature } from '@gig/magic-messages';

/**
 * Used for backwards compatibility.
 */

export enum PasswordResetTypes {
    EMAIL = 'EMAIL',
    SMS = 'SMS',
}

export const featureRouteMap: Partial<Record<Feature, string>> = {
    [Feature.PROMOTIONS]: 'promotions',
    [Feature.SHOP]: 'shop',
    [Feature.REWARDS]: 'rewards',
    [Feature.TOURNAMENTS]: 'tournaments',
    [Feature.DASHBOARD]: 'dashboard',
    [Feature.SPORTSBOOK]: 'sports',
    [Feature.BINGO_LOBBY]: 'bingo-lobby',
};

export function isHybridPnP() {
    return window.queryBus.query<string, boolean>(
        FEATURE_QUERY_ENABLED,
        Feature.HYBRID_PAY_AND_PLAY,
    );
}

export function isPurePnP() {
    return window.queryBus.query<string, boolean>(
        FEATURE_QUERY_ENABLED,
        Feature.PURE_PAY_AND_PLAY,
    );
}

export function isSubdivisionRequired() {
    return window.queryBus.query<string, boolean>(
        FEATURE_QUERY_ENABLED,
        Feature.SUBDIVISION_REQUIRED,
    );
}

export function isTopNavEnabled() {
    return window.queryBus.query<string, boolean>(
        FEATURE_QUERY_ENABLED,
        Feature.TOP_NAVIGATION,
    );
}

export function isEnhancedCoversOnStaticPagesEnabled() {
    return window.queryBus.query<string, boolean>(
        FEATURE_QUERY_ENABLED,
        Feature.ENHANCED_COVERS_ON_STATIC_PAGES,
    );
}

export function getRoutePathForFeature(feature: Feature) {
    return featureRouteMap[feature] || undefined;
}
